/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Button } from '@squiz/sds';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React, { useRef } from 'react';
import { DialogLauncherProps } from './DialogLauncher.props';

/**
 * SDS Dialog component launcher.
 */
export const DialogLauncher = (props: DialogLauncherProps): JSX.Element => {
  const { buttonProps, dialogProps } = props;
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { updateActiveDialog } = useDialogStore();

  // Handle opening the dialog
  const openDialog = (): void => {
    updateActiveDialog(dialogProps);
  };

  buttonProps.onClick = openDialog;

  // Handle dialog state
  dialogProps.stateHandler = useDialogStore;

  return <Button {...buttonProps} ref={buttonRef} />;
};
